import { useMemo } from 'react';

export default function useDefaultValue<T>(value: T | undefined, defaultValue: T): T
{
  return useMemo(() => value === undefined? defaultValue : value, [value, defaultValue]);
}